import api from "@/services/api-config/rxjs-config";
import axios, { InternalAxiosRequestConfig } from "axios";
import { Observable } from "rxjs";

export interface GenerateQuizRequest {
  learning_object_id: string;
  remake: boolean;
}

export interface QuestionItem {
  id?: string;
  answerType: string;
  answerText: string;
  answerDescription?: string;
  correct: boolean;
}

export interface QuestionToSave {
  itemTOS: QuestionItem[];
  prompt: string;
  promptType: string;
  type: string;
}

export class GenerateQuizRest {
  baseURL = "/quiz";

  postGenerateQuiz(data: GenerateQuizRequest): Promise<any> {
    const url: string = `/generate_quiz`;
    const api = axios.create({ baseURL: this.baseURL });
    api.interceptors.request.use(
      (request: InternalAxiosRequestConfig) => {
        request.headers.set(
          "Authorization",
          `Bearer ${process.env.VUE_APP_URL_GENERATE_QUIZ_TOKEN}`
        );
        return request;
      },
      (error) => Promise.reject(error)
    );
    return api.post(url, data).then((response) => response.data);
  }

  postSaveAllQuestions(
    quizId: string,
    questions: QuestionToSave[]
  ): Observable<any> {
    const url: string = `/quiz/${quizId}/questions/batch`;
    return api.post(url, questions);
  }
}
